import React from 'react';
import AgentDashboard from './frontend/AgentDashboard';

function App() {
  return (
    <div className="App">
      <AgentDashboard />
    </div>
  );
}

export default App;